import { api } from "services"

export async function createDocument(payload: any) {
  const { data } = await api.post(`reverse-logistics/document`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return data;
}